import Dialog from "rc-dialog";
import { SyntheticEvent } from "react";

export interface ModalProps {
  /** 对话框是否可见 */
  visible: boolean;
  /** 内容 */
  children: React.ReactElement;
  /** 标题 */
  title?: React.ReactNode;
  /** 是否显示右上角的关闭按钮 */
  closable?: boolean;
  /** 点击蒙层是否允许关闭 */
  maskClosable?: boolean;
  zIndex?: number;
  /** 关闭回掉 */
  onClose: (e: SyntheticEvent<Element, Event>) => any;
}

const Modal = (props: ModalProps) => {
  return (
    <Dialog
      {...props}
      closable={false}
      prefixCls="rf-modal"
      transitionName="rf-zoom"
      maskTransitionName="rf-fade"
    >
      {props.children}
    </Dialog>
  );
};

export default Modal;
